$(function () {

  //выцепляем яблоки, вешаем класс
  if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
    $('body').addClass('ios')
  }

  window.pm = {};

  window.pm.obj = ({

    digitsStart: false,

    fixedSidebar: function () {

      var stickyEl = $('.js-sticky'),
        parEl = stickyEl.parents('.main__left'),
        header = $('.header'),
        bottomBorder = stickyEl.parents('.main__row'),
        corr = 100;

      $(window).on('resize scroll', function () {
        var ww = $(window).width(),
          scrollTop = $(window).scrollTop(),
          windowHeight = $(window).height();

        var parElOffset = parEl.offset(),
          headerOffset = header.offset(),
          headerHeight = header.outerHeight(true),
          headerFixedHeight = $('.header__fixed').outerHeight(true),
          bottomBorderHeight = bottomBorder.outerHeight(true),
          bottomBorderOffset = bottomBorder.offset();

        if (ww > 991) {

          if (parElOffset.top + corr < headerHeight + scrollTop) {
            stickyEl
              .addClass('fixed')
              .css({
                'left': parElOffset.left
              });

            if ((bottomBorderHeight + bottomBorderOffset.top + (windowHeight - stickyEl.outerHeight() - 170)) < (windowHeight + scrollTop)) {
              stickyEl.addClass('bottom');
            } else {
              stickyEl.removeClass('bottom');
            }

          } else {
            if (parElOffset.top + corr > headerHeight + scrollTop) {
              stickyEl.removeClass('fixed bottom').removeAttr('style');
            }
          }

        } else {
          stickyEl
            .removeAttr('style')
            .removeClass('fixed bottom')
            .fadeOut(0);
        }

      });

    },
    closeCatalogMenu: function () {
      var $body = $('body');
      if ($body.hasClass('catalog-menu-open')) {
        $('.js-toogle-catmenu').click();
      }
      if ($('html').hasClass('open-menu-mobile')) {
        $('.js-toogle-menu').click();
      }
    },

    scrollToAnchors: function () {
      var $anchorLinks = $('.js-anchors .anchors__item-href, .js-anchors-link'),
        _th = this,
        body = $("html, body"),
        fixedHeader = $('.header__fixed'),
        corr = 30;

      function lazyScrollTo($targetItem) {
        body.stop().animate(
          {
            scrollTop: $targetItem.offset().top - fixedHeader.outerHeight(true) - corr
          },
          {
            duration: 2000,
            step: function (now, fx) {

              // Where is the target now located on the page?
              // i.e. its location will change as images etc. are lazy loaded
              var newOffset = $targetItem.offset().top - fixedHeader.outerHeight(true) - corr;

              // If where we were originally planning to scroll to is not
              // the same as the new offset (newOffset) then change where
              // the animation is scrolling to (fx.end).
              if (fx.end !== newOffset)
                fx.end = newOffset;
            }
          });
      }

      $anchorLinks.on('click', function () {
        var _t = $(this),
          dataAnchors = _t.data('anchor');

        _th.closeCatalogMenu();

        var $targetItem = $('[data-anchor-item="' + dataAnchors + '"]');
        if ($targetItem.length) {
          lazyScrollTo($targetItem);
        }

        return true;
      });

      if (window.location.hash.length > 1) {
        setTimeout(function () {
          var $targetItem = $('[data-anchor-item="' + window.location.hash.replace('#', '') + '"]');
          lazyScrollTo($targetItem);
        }, 500);
      }
    },

    init: function () {

      var _th = this,
        $body = $('body');

      if ($('.js-sticky').length) {
        _th.fixedSidebar();
      }

      var $anchorContainer = $('.js-anchors'),
        $targetItems = $('.main__right h2');
      if ($anchorContainer.length && $targetItems.length) {
        $anchorContainer.parents('.main__left').addClass('main__left--has-anchors');
        var template = function (id, title) {
            return '<li class="anchors__item">' +
              '<a class="anchors__item-href" href="#' + id + '" data-anchor="' + id + '">' + title + '</a></li>';
          },
          links = '',
          isElementInViewport = function (el) {
            var rect = el.getBoundingClientRect();
            return (
              rect.top >= 0 &&
              rect.left >= 0 &&
              rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
              rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
          },
          isElementInTop = function (el) {
            var rect = el.getBoundingClientRect();
            return rect.top < 200;
          },
          activateAnchorLink = function ($target) {
            var first = $anchorContainer.find('[data-anchor=' + $target.attr('data-anchor-item') + ']');
            if (!first.hasClass('anchors__item-href--active')) {
              $('.anchors__item-href').removeClass('anchors__item-href--active');
              first.addClass('anchors__item-href--active');
            }
          }
        ;

        $targetItems.map(function (i, item) {
          links += template(i, item.innerHTML);
          item.setAttribute('data-anchor-item', i);
        });

        $(window).on('scroll', function () {
          var $onScreen = $targetItems.filter(function () {
            return isElementInViewport(this);
          });
          if ($onScreen.length) {
            activateAnchorLink($onScreen.eq(0));
          } else {
            var $onTop = $targetItems.filter(function () {
              return isElementInTop(this);
            });
            if ($onTop.length) {
              activateAnchorLink($onTop.eq($onTop.length - 1));
            } else {
              $('.anchors__item-href').removeClass('anchors__item-href--active');
            }
          }
        });
        $anchorContainer.html(links);
        _th.scrollToAnchors();
      }

      $('.js-phone').mask('9(999) 999-9999');

      $('.js-digits').keydown(function (e) {
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
          (e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
          (e.keyCode >= 35 && e.keyCode <= 40)) {
          return;
        }
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
          e.preventDefault();
        }
      });

      function masonrySublist(margin, par) {
        var container = par ? $(".catalog-menu .js-masonry-sublist") : $(".catalog--page .js-masonry-sublist");
        //setTimeout(function () {
        container.masonry({
          itemSelector: '.catalog-menu__subitem--grid-masonry',
          columnWidth: '.catalog-menu__subitem--grid-masonry',
          gutter: margin,
          isResizeBound: false,
        });
        //}, 50);
      }

      function fixedScroll(wst) {
        var header = $('.header'),
          headerFixed = $('.header__fixed'),
          headerHeight = header.outerHeight(true),
          headerCompare = $('.header__compare');

        $(window).scroll(function () {
          var ww = $(window).width(),
            wh = $(window).height(),
            wst = $(window).scrollTop();

          if (ww > 767) {

            if (headerHeight < wst) {
              headerFixed.addClass('show');
              $('.header__middle .header__search').fadeOut(350);
              $('.header__middle .header__action-href--search').removeClass('show-search');
            } else {
              headerFixed.removeClass('show');
              $('.header__fixed .header__search').fadeOut(350);
              $('.header__fixed .header__action-href--search').removeClass('show-search');
            }

            if ($('.main .products--compare-item').length && $('.header .products--compare-item').length) {
              var compareItem = $('.main .products--compare-item'),
                compareItemOffset = compareItem.offset();

              if (wst > (compareItemOffset.top + compareItem.outerHeight(true) + 70)) {
                headerCompare.addClass('show');
              } else {
                headerCompare.removeClass('show');
              }
            }
          }

        });
      }

      function runIt() {
        if ($('.header__action-counter').length && $('.header__action-expected').length) {
          var basketIco = $('.header__action-href--basket');

          if (basketIco.hasClass('header__action-href--counter')) {
            basketIco
              .removeClass('header__action-href--counter')
              .addClass('header__action-href--expected');
          } else {
            basketIco
              .removeClass('header__action-href--expected')
              .addClass('header__action-href--counter');
          }
        } else {
          $('.header__action-href--basket').addClass('header__action-href--counter');
        }
      }

      if ($('.js-auto-change-count').length) {
        setInterval(function () {
          runIt();
        }, 10000);
      }

      if ($('.js-iann-swiper').length) {
        if ($('.js-iann-swiper .swiper-slide:not(".swiper-slide-duplicate") .iann__content').length > 1) {
          $('.swiper-button-next, .swiper-button-prev, .swiper-pagination').removeClass('hidden');
        } else {
          $('.swiper-button-next, .swiper-button-prev, .swiper-pagination').addClass('hidden');
        }
        var iannSlider = new Swiper('.js-iann-swiper', {
          loop: true,
          speed: 750,
          slidesPerView: 1,
          spaceBetween: 0,
          mousewheel: false,
          grabCursor: false,
          keyboard: false,
          simulateTouch: false,
          allowSwipeToNext: false,
          allowSwipeToPrev: false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          breakpoints: {
            479: {
              autoHeight: true
            },
          },
          on: {
            slideChangeTransitionStart: function () {
              if ($('.swiper-slide-active .iann__content--dark').length) {
                $(this)[0].$el.parents('.iann').addClass('content--dark');
              } else {
                $(this)[0].$el.parents('.iann').removeClass('content--dark');
              }
            }
          }
        });

      }

      if ($('.js-irev-swiper').length) {
        var irevSlider = new Swiper('.js-irev-swiper', {
          loop: true,
          speed: 750,
          slidesPerView: 2,
          spaceBetween: 30,
          mousewheel: false,
          grabCursor: false,
          keyboard: false,
          simulateTouch: false,
          allowSwipeToNext: false,
          allowSwipeToPrev: false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          breakpoints: {
            991: {
              slidesPerView: 1,
              spaceBetween: 5
            }
          }
        });
      }

      if ($('.js-swiper-compare').length) {

        var titleItem = $('.swiper-slide:first-child .compare__cell-char span');

        function titleClearStyle() {
          titleItem.removeAttr('style');
        }

        function titleCalcTop() {
          $(window).resize(function () {
            var vw = $(window).width();
            var offTop = $('.js-swiper-compare').offset().top;

            if (vw < 992) {
              titleItem.each(function () {
                var _t = $(this);
                _t.css({
                  'top': '',
                  'position': 'absolute'
                });
                _t.css({
                  'top': (_t.offset().top - offTop - 15),
                  'position': 'fixed'
                });
              });
            } else {
              titleClearStyle();
            }
          });
        }

        function titleCaclLeft(arg) {
          $(window).resize(function () {
            var vw2 = $(window).width();

            if (vw2 < 992) {
              titleItem.each(function () {
                var _t = $(this);
                _t.css({
                  'left': Math.abs(arg)
                });
              });
            } else {
              titleClearStyle();
            }
          }).trigger('resize');
        }

        var compareHeaderSlider = new Swiper('.js-swiper-header-compare', {
          loop: false,
          speed: 750,
          slidesPerView: 'auto',
          spaceBetween: 30,
          mousewheel: false,
          grabCursor: false,
          keyboard: false,
          simulateTouch: false,
          allowSwipeToNext: false,
          allowSwipeToPrev: false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        });

        var compareSlider = new Swiper('.js-swiper-compare', {
          loop: false,
          speed: 750,
          slidesPerView: 'auto',
          spaceBetween: 30,
          mousewheel: false,
          grabCursor: false,
          keyboard: false,
          simulateTouch: false,
          allowSwipeToNext: false,
          allowSwipeToPrev: false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          on: {
            init: function () {
              var cellChar = $('.compare__cell-char'),
                max = 0;
              cellChar.each(function () {
                var h = $(this).height();
                max = Math.max(max, h);
              }).height('').height(max);

              titleCalcTop();

            },
            slidePrevTransitionStart: function () {
              compareHeaderSlider.slidePrev(750);
            },
            slideNextTransitionStart: function () {
              compareHeaderSlider.slideNext(750);
            },
            transitionEnd: function () {
              titleCaclLeft(compareSlider.translate);
            },
            resize: function () {
              titleCalcTop();
            }
          }
        });

        $('.js-swiper-header-compare .swiper-button-prev').on('click', function () {
          $('.js-swiper-compare .swiper-button-prev').click();
          return false;
        });

        $('.js-swiper-header-compare .swiper-button-next').on('click', function () {
          $('.js-swiper-compare .swiper-button-next').click();
          return false;
        });

      }

      if ($('.catalog-menu .js-masonry-sublist').length) {
        masonrySublist(10, true);
      }

      if ($('.catalog--page .js-masonry-sublist').length && $(window).width() > 767) {
        masonrySublist(30, false);
      }

      if ($('.js-photo-slider').length) {
        var photoSlider = new Swiper('.js-photo-slider', {
          loop: false,
          speed: 750,
          slidesPerView: 1,
          spaceBetween: 0,
          mousewheel: false,
          grabCursor: false,
          keyboard: false,
          simulateTouch: false,
          allowSwipeToNext: false,
          allowSwipeToPrev: false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          }
        });
      }

      if ($('.js-select-complex').length) {
        $('.js-select-complex').styler({
          selectSmartPositioning: false,
          onFormStyled: function () {
            var selectComplex = $('.js-select-complex'),
              li = selectComplex.find('li'),
              selectedLi;

            li.each(function () {
              var _t = $(this),
                _tDAta = _t.data('schedule');
              if (_tDAta && _tDAta.length) {
                var span = '<span class="form__field-select-subtext">' + _tDAta + '</span>';
                _t.append(span);
              }
            });

            selectedLi = selectComplex.find('li.selected');

            selectedLi.each(function () {
              var _tSpanText = $(this).find('span').text();
              $(this).parents('.jq-selectbox').find('.jq-selectbox__select-text').append('<span>' + _tSpanText + '<span/>');
            });

          },
          onSelectClosed: function () {
            var _t = $(this);
            if (_t.hasClass('js-select-complex')) {
              var selectedSpan = !!_t.find('li.selected span').length;
              if (selectedSpan) {
                if (!_t.find('.jq-selectbox__select-text span').length) {
                  _t.find('.jq-selectbox__select-text').append('<span>' + _t.find('li.selected span').text() + '<span/>');
                } else {
                  _t.find('.jq-selectbox__select-text span').text(_t.find('li.selected span').text());
                }
              }
            }
          }
        });
      }

      if ($('.js-select').length) {
        $('.js-select').styler({
          selectSmartPositioning: false
        });
      }

      if ($(".js-lightgallery").length) {
        $(".js-lightgallery").lightGallery({
          selector: 'a'
        });
      }

      if ($('.js-toogle-menu').length) {
        var toogleMenu = $('.js-toogle-menu');
        toogleMenu.on('click', function () {
          var _t = $(this),
            headerBottom = $('.header__bottom'),
            html = $('html');
          if (!_t.hasClass('open')) {
            _t.addClass('open');
            html.addClass('open-menu-mobile');
            headerBottom.slideDown(350);
          } else {
            _t.removeClass('open');
            html.removeClass('open-menu-mobile');
            headerBottom.slideUp(350);
            $('.catalog-nav__list .catalog-nav__href').removeClass('show-menu-level2 show-menu-level3').text('Каталог').removeAttr('data-level2 data-height-level2 data-level3');
            $('.catalog-nav__sublist').removeAttr('style');
            $('.js-toogle-catmenu').removeClass('open');
            $('.catalog-nav__list-mobile').fadeOut(0).removeAttr('style');
            $('.nav').fadeIn(0);
          }
        });
      }

      if ($('.js-toogle-catmenu').length) {
        var btnToogle = $('.js-toogle-catmenu');
        btnToogle.on('click', function () {
          var _t = $(this),
            catalogMenu = $('.catalog-menu'),
            catalogNav = _t.parents('.catalog-nav'),
            catalogNavMenu = catalogNav.find('.catalog-nav__list-mobile');

          if ($(window).width() > 767) {

            if (_t.parents('.header__fixed').length) {
              var hfh = $('.header__fixed').outerHeight(true);
              if (!_t.hasClass('open')) {
                _t.addClass('open');
                catalogMenu.addClass('catalog-menu_fixed').stop().fadeIn(350);
                $body.addClass('catalog-menu-open')
              } else {
                _t.removeClass('open');
                catalogMenu.stop().fadeOut(350).removeClass('catalog-menu_fixed').removeAttr('style');
                $body.removeClass('catalog-menu-open');
                $('.catalog-menu__item').removeClass('catalog-menu__item--show-sublist');
              }
            } else {
              if (!_t.hasClass('open')) {
                _t.addClass('open');
                catalogMenu.stop().fadeIn(350);
                $body.addClass('catalog-menu-open')
              } else {
                _t.removeClass('open');
                catalogMenu.stop().fadeOut(350);
                $body.removeClass('catalog-menu-open');
                $('.catalog-menu__item').removeClass('catalog-menu__item--show-sublist');
              }
            }

            masonrySublist(10, true);

          } else {
            if (!_t.hasClass('open')) {
              _t.addClass('open');
              catalogNavMenu.fadeIn(350);
              catalogNav.siblings('nav').fadeOut(0);
            } else {
              if (!_t.hasClass('show-menu-level2') && !_t.hasClass('show-menu-level3')) {
                _t.removeClass('open');
                catalogNav.siblings('nav').fadeIn(0);
                catalogNavMenu.fadeOut(350).removeAttr('style');
              } else {
                if (_t.hasClass('show-menu-level3')) {
                  _t.text(_t.data('level2'));
                  catalogNavMenu.height(_t.data('height-level2'));
                  _t.removeClass('show-menu-level3').addClass('show-menu-level2');
                  $('.catalog-nav__sublist--level3').removeAttr('style');
                } else if (_t.hasClass('show-menu-level2')) {
                  _t.text('Каталог');
                  _t.removeClass('show-menu-level2');
                  catalogNavMenu.css('height', 'auto');
                  $('.catalog-nav__sublist:not(.catalog-nav__sublist--level3)').removeAttr('style');
                }
              }
            }
          }

          return false;
        });
      }

      //close mobile catalog in header
      $('.js-close-catalog-nav').on('click', function () {
        var _t = $(this),
          catalogMenu = $('.catalog-menu'),
          catalogNav = _t.parents('.catalog-nav'),
          catalogNavMenu = catalogNav.find('.catalog-nav__list-mobile'),
          btnToogle = $('.js-toogle-catmenu');

        btnToogle.removeClass('open').text('Каталог').removeClass('show-menu-level3 show-menu-level2');
        $('.catalog-nav__sublist').removeAttr('style');
        catalogNav.siblings('nav').fadeIn(0);
        catalogNavMenu.fadeOut(350).removeAttr('style');

      });
      $('.catalog-nav__href_sublevel').on('click', function () {
        const link_href = $(this).attr('href');
        if (link_href) {
          $('.full-loader').removeClass('h-invisible');
          window.location.href = link_href;
        }
      });
      $('.js-toogle-sublist').on('click', function () {
        var _t = $(this),
          heightMenu = _t.siblings('.catalog-nav__sublist').outerHeight(true),
          catalogMobile = $('.catalog-nav__list-mobile'),
          headHref = $('.catalog-nav__list .catalog-nav__href'),
          newText;

        if (_t.siblings('.catalog-nav__sublist--level3').length) {
          headHref.removeClass('show-menu-level2').addClass('show-menu-level3');
          newText = _t.text();
          headHref.attr('data-level3', newText);
        } else {
          headHref.removeClass('show-menu-level3').addClass('show-menu-level2');
          newText = _t.text();
          headHref.attr('data-level2', newText).attr('data-height-level2', heightMenu)
        }

        catalogMobile.height(heightMenu);
        _t.siblings('.catalog-nav__sublist').fadeIn(350);
        headHref.text(newText);

        setTimeout(function () {
          console.log('12');
          $('.header__bottom > .container').animate({scrollTop: 0}, 750);
        }, 100);

        return false;
      });

      if ($('.js-close-catmenu').length) {
        var btnClose = $('.js-close-catmenu');
        btnClose.on('click', function () {
          $('.js-toogle-catmenu').removeClass('open');
          $('.catalog-menu').stop().fadeOut(350).removeClass('catalog-menu_fixed').removeAttr('style');
          $('.catalog-menu__item').removeClass('catalog-menu__item--show-sublist');
          $('.catalog-menu__item').first().addClass('catalog-menu__item--show-sublist');
          $body.removeClass('catalog-menu-open');
          return false;
        });
      }

      $('.catalog-menu__item').on('mousemove', function () {
        var _t = $(this),
          allItem = $('.catalog-menu__item');
        if (!_t.hasClass('catalog-menu__item--show-sublist') && _t.find('.catalog-menu__sublist').length) {
          allItem.removeClass('catalog-menu__item--show-sublist');
          _t.addClass('catalog-menu__item--show-sublist');
        }
      });

      $('.header__search-input').on('keyup', function () {
        if ($(this).val() != '') {
          $(this).parents('.header__search-form').addClass('no-empty');
        } else {
          $(this).parents('.header__search-form').removeClass('no-empty');
        }
      });

      $('.form__field-input, .form__field-textarea').on('change', function () {
        if ($(this).val() != '') {
          $(this).addClass('no-empty');
        } else {
          $(this).removeClass('no-empty');
        }
      });

      if ($('.js-show-search').length) {
        $('.js-show-search').on('click', function () {
          var _t = $(this);

          if (!_t.hasClass('show-search')) {
            _t.parents('.header').addClass('header__search-open');
            if (_t.parents('.header__fixed').length) {
              _t.parents('.header__fixed').find('.header__search').fadeIn(350);
              _t.addClass('show-search');
            } else {
              _t.parents('.header__middle').find('.header__search').fadeIn(350);
              _t.addClass('show-search');
            }
          }
          return false;
        });
      }

      if ($('.js-close-search').length) {
        $('.js-close-search').on('click', function () {
          $(this).parents('.header').removeClass('header__search-open');
          $(this).parents('.header__search').fadeOut(350);
          $('.header__action-href--search').removeClass('show-search');
          return false;
        });
      }

      if ($('.js-fixed-scroll').length) {
        fixedScroll();
      }

      var rangeInp = $('.js-range');
      if (rangeInp.length) {

        rangeInp.each(function () {
          var _th = $(this),
            _thMax = parseInt(_th.data('max')),
            _thMin = parseInt(_th.data('min')),
            inpTo = _th.parents('.range').find('.range__input--to'),
            inpFrom = _th.parents('.range').find('.range__input--from');

          var values = _th.val().split(';');

          _th.ionRangeSlider({
            type: "double",
            min: _thMin,
            max: _thMax,
            from: values[0] || 0,
            to: values[1] || 0,
            keyboard: true,
            onStart: function (data) {
              //console.log("onStart");
            },
            onChange: function () {
              /*
              var $this = $(this),
                  value = $this.prop("value"),
                  inpDef = data.input["0"].parentNode.children[1];
              inpDef.vaue(value);
              */
            },
            onFinish: function (data) {
              //console.log("onFinish");
            },
            onUpdate: function (data) {
              //console.log("onUpdate");
            }
          });

          _th.on("change", function () {
            var $this = $(this),
              from = $this.data("from"),
              to = $this.data("to");
            inpTo.val(to);
            inpFrom.val(from);
          });

        });
      }

      var fotorama_init = function ($selector) {
        var $fotoramaDiv = $selector.fotorama();
        var fotorama = $fotoramaDiv.data('fotorama');
      };

      if ($(".js-fotorama").length) {
        $(window).load(function () {
          fotorama_init($(".js-fotorama"));
        });
      }

      window.fotorama_init = fotorama_init;

      if ($('.js-mfp').length) {
        var width = $(window).outerWidth();
        $(window).on('resize', function () {
          width = $(window).outerWidth();
        });

        $('.js-mfp').magnificPopup({
          type: 'inline',
          midClick: true,
          callbacks: {
            open: function () {
              $('.js-absolute').css({
                'padding-right': Math.abs(width - $(window).outerWidth()) + 'px',
                'overflow-x': 'hidden',
                'transition': 'none'
              });
            },
            close: function () {
              $('.js-absolute').css({'padding-right': '', 'overflow-x': ''});
            },
            imageLoadComplete: function () {
              if ($(".popup .js-fotorama-popup").length) {
                fotorama_init($(".js-fotorama-popup"));
              }
            }
          }
        });
      }

      $('.js-close-popup').on('click', function () {
        $.magnificPopup.close();
        return false;
      });

      if ($('.js-tipsy').length) {
        $('.js-tipsy').tipsy({gravity: 's', offset: 10, opacity: 1, fade: 350});
      }

      if ($('.js-tipsy-html').length) {
        $('.js-tipsy-html').tipsy({
          className: 'tipsy--html',
          trigger: 'manual',
          html: true,
          gravity: 's',
          offset: 10,
          opacity: 1
        });
        $('.js-tipsy-html').on('click', function () {
          var _t = $(this);
          if (!_t.hasClass('show-tipsy')) {
            $('.js-tipsy-html').each(function () {
              $(this).removeClass('show-tipsy').tipsy("hide");
            });
            _t.addClass('show-tipsy');
            _t.tipsy("show");
          } else {
            _t.removeClass('show-tipsy');
            _t.tipsy("hide");
          }
          return false;
        });
      }

      if ($('.js-animateNumber').length) {
        var numberPar = $('.idone__items');

        $(window).scroll(function () {
          if (numberPar.length && !_th.digitsStart && numberPar.offset().top < $(window).scrollTop() + $(window).height()) {
            _th.digitsStart = true;
            var sep = $.animateNumber.numberStepFactories.separator(' ');
            $('.js-animateNumber').each(function () {
              var th = $(this);
              var numb = $(this).data('digits');

              var decimal_places = 0;
              var decimal_factor = 1;

              if ($(this).data('sep')) {
                decimal_places = $(this).data('sep');
                decimal_factor = Math.pow(10, decimal_places);
              }

              setTimeout(function () {
                th.animateNumber({
                  number: numb * decimal_factor,
                  numberStep: function (now, tween) {
                    var floored_number = Math.floor(now) / decimal_factor,
                      target = $(tween.elem);

                    if (decimal_places > 0) {
                      floored_number = floored_number.toFixed(decimal_places);
                      floored_number = floored_number.toString().replace('.', ',');
                      target.find('span').text(floored_number);
                    } else {
                      target.find('span').text(String(floored_number).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 '));
                    }
                  }
                }, 2500, function () {
                  th.addClass('complete');
                });

              }, 250);

            });
          }
        });
      }

      $('.filter-prod__item-btn').on('click', function () {
        var _th = $(this),
          parents = _th.parents('.filter-prod__item'),
          content = parents.find('.filter-prod__item-content');

        if (parents.hasClass('filter-prod__item--open')) {
          content.slideUp(350, function () {
            parents.removeClass('filter-prod__item--open');
          });
        } else {
          content.slideDown(350, function () {
            parents.addClass('filter-prod__item--open');
          });
        }

        return false;
      });

      var btnOpening = $('.js-opening');
      if (btnOpening.length) {
        btnOpening.on('click', function () {
          var _t = $(this),
            contentOpening = _t.siblings('.requisites__opening-content'),
            _tParents = _t.parents('.requisites__opening');

          if (!_tParents.hasClass('requisites__opening--show-content')) {
            contentOpening.stop().slideDown(400);
            setTimeout(function () {
              _tParents.addClass('requisites__opening--show-content');
            }, 400);
          } else {
            contentOpening.stop().slideUp(400);
            setTimeout(function () {
              _tParents.removeClass('requisites__opening--show-content');
            }, 400);
          }

          return false;
        });
      }

      var datepicker = $('.js-datepicker');

      if (datepicker.length) {
        datepicker.each(function () {
          $(this).datepicker({
            position: "bottom right",
            dateFormat: 'dd.mm.yy'
          });
        });
      }

      var $contentTables = $(".text table:not(.no-scroll)");

      if ($contentTables.length) {
        $contentTables.each(function () {
          $(this).wrap('<div class="table-wrap-scroll"><div class="table-wrap">');
        });
      }

      if ($('.js-anchor').length) {
        $('.js-anchor').on('click', function () {
          var _t = $(this),
            _tData = _t.data('ahchor');
          if (_tData.length && $('[data-ahchor-item="' + _tData + '"]').length) {
            $('html, body').animate({scrollTop: $('[data-ahchor-item="' + _tData + '"]').offset().top - 100}, 850);
          }

          return false;
        });
      }

      var $shave = $('.js-shave');

      if ($shave.length) {
        $shave.each(function () {
          var _t = $(this),
            _tHeight = parseInt(_t.data('shave'), 10);
          if (!isNaN(_tHeight) && _tHeight !== 0) {
            _t.shave(_tHeight);
          }
        });
      }

      $(document).on('click', function (e) {
        if (!$(e.target).closest('.products__faq').length && $('.products__faq.show-tipsy').length) {
          $('.js-tipsy-html').each(function () {
            $(this).removeClass('show-tipsy').tipsy('hide');
          });
        }
      });

      function fixedEl(addAttrLeft, left) {
        var el = $('.js-fixed');
        left = left ? Math.abs(left) : 0;
        addAttrLeft = !!addAttrLeft;

        if ($(window).width() < 1199) {

          if (addAttrLeft) {
            el.each(function () {
              var _t = $(this);
              _t.attr('data-start-left', _t.css('left'));
            });
          }

          el.each(function () {
            var _t = $(this),
              startLeft = _t.data('start-left') ? parseInt(_t.data('start-left')) : 0;
            _t.css({
              'left': left + startLeft
            });
          });

        } else {
          el.removeAttr('style').removeAttr('data-start-left');
        }
      }

      if ($('.js-fixed').length) {
        //добавляю атрибут
        fixedEl(true, 0);

        $('.js-fixed').parents('.catalog__content').scroll(function (e) {
          fixedEl(false, e.target.scrollLeft);
        });
      }

      var $addIcoArrow = $(".js-add-ico-mobile");

      if ($addIcoArrow.length) {
        $addIcoArrow.each(function () {
          $("<i class=\"arrow-ico\">").insertBefore($(this));
        });
      }

      /*
      if ($('.js-customScrollBar, .table-wrap').length) {
          $('.js-customScrollBar, .table-wrap').mCustomScrollbar({
              theme: "dark",
              axis: "x",
              scrollButtons: {
                  enable: true,
              },
              advanced: {
                  autoScrollOnFocus: false,
              },
              callbacks: {
                  onInit: function () {
                      if ($('.js-fixed').length) {
                          //добавляю атрибут
                          fixedEl(true, 0);
                      }
                  },
                  whileScrolling: function () {
                      if ($('.js-fixed').length) {
                          var left = this.mcs.left;
                          //позиционирую
                          fixedEl(false, left);
                      }
                  }
              }
          });
      }
      */

      var TAB_ITEM_ACTIVE = 'tabs__item--active',
        TAB_NAV_ACTIVE = 'tabs__nav-btn--active';
      window.tabs_activate = function ($tabs) {
        $tabs.each(function (i) {
          var $container = $tabs.eq(i),
            $buttons = $container.find('.tabs__nav-btn');

          $buttons.on('click', function (e) {
            e.preventDefault();
            if (this.disabled === false) {
              var $tab_content = $container.find('.tabs__item[data-tabs-item=' + this.dataset.tabsNav + ']');
              if ($tab_content.length) {
                $container.find('.' + TAB_ITEM_ACTIVE).removeClass(TAB_ITEM_ACTIVE);
                $container.find('.' + TAB_NAV_ACTIVE).removeClass(TAB_NAV_ACTIVE);
                $tab_content.addClass(TAB_ITEM_ACTIVE);
                this.classList.add(TAB_NAV_ACTIVE);

                if ($tab_content.find('.js-yandex-map').length) {
                  window.pm.map.showMap();
                }
              }
            }
          })
        });
      };
      var $tabs = $('.tabs');
      if ($tabs.length) {
        tabs_activate($tabs);
      }

      $('.js-share').on('click', function (e) {
        e = (e ? e : window.event);
        var t = (e.target ? e.target : e.srcElement),
          width = t.data - width || 800,
          height = t.data - height || 500;

        // popup position
        var px = Math.floor(((screen.availWidth || 1024) - width) / 2),
          py = Math.floor(((screen.availHeight || 700) - height) / 2);

        // open popup
        var popup = window.open(t.href, "social",
          "width=" + width + ",height=" + height +
          ",left=" + px + ",top=" + py +
          ",location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1");

        if (popup) {
          popup.focus();
          if (e.preventDefault) e.preventDefault();
          e.returnValue = false;
        }

        return !!popup;
      });

      $(window).trigger('scroll').trigger('resize');
    }

  }).init();

  window.pm.map = {
    inited: false,
    popupMap: null,
    contactMap: null,

    intiContactsMap: function () {
      var $contact_items = $('.js-contact-item'),
        myMap = window.pm.map.contactMap;

      if ($contact_items.length) {
        $contact_items.each(function () {
          try {
            var data = JSON.parse(this.dataset.json);
            var placeMark = new ymaps.Placemark([data.lat, data.lng], {
              balloonContent: data.title ? data.title + '<br>' + data.content : data.content
            }, {
              preset: 'islands#icon',
              iconColor: '#FF931E'
            });

            myMap.geoObjects.add(placeMark);

            $(this)
              .find('.js-scroll-to-point')
              .on('click', function () {
                myMap
                  .setCenter([data.lat, data.lng], data.zoom || 11, {
                    checkZoomRange: true,
                    duration: 500,
                    timingFunction: 'ease-in-out'
                  })
                  .catch(function (err) {
                    console.log(err);
                  });
              });
          } catch (e) {
            console.log(e);
          }
        });
      }
      if (myMap.geoObjects.getLength() > 0) {
        myMap.setBounds(myMap.geoObjects.getBounds(), {
          checkZoomRange: true,
        }).then(function () {
          console.log('успех');
        }, function (err) {
          console.error(err);
        });
      }
    },
    init: function () {
      var $maps = $('.js-yandex-map');
      if ($maps.length) {
        window.pm.map.inited = true;
        // только по требованию грузим яндекс карты
        if (!window.hasOwnProperty('ymaps')) {
          $.getScript('https://api-maps.yandex.ru/2.1/?lang=ru_RU', window.pm.map.init);
          return;
        }
        ymaps.ready(function () {
          $maps.each(function () {
            var myMap = new ymaps.Map(this, {
              center: [56.033108, 92.798601],
              zoom: 16,
              controls: ['largeMapDefaultSet']
            });

            myMap.controls.add('zoomControl', {size: 'small'});
            myMap.behaviors.disable('scrollZoom');

            // пока подразумевается наличие всего двух карт
            // надо будет переделывать если появятся ещё
            if (this.classList.contains('js-contact-map')) {
              window.pm.map.contactMap = myMap;
              window.pm.map.intiContactsMap();
            } else {
              window.pm.map.popupMap = myMap;
            }
          });
        }).catch(function (e) {
          console.log(e);
        });
      }

      return this;
    },

    /**
     * Функция показа карты которая была в не активном табе при инициализации
     */
    showMap: function () {
      if (window.pm.map.popupMap) {
        window.pm.map.popupMap.container.fitToViewport();
      }
    }

  };

  window.pm.map.init();

  var forms = document.querySelectorAll('.js-form');
  if (forms.length) {
    forms.forEach(function (item) {
      var form = new TurboForm(item, {
        errorClass: 'warning',
        unholdFormAfterSuccess: true,
        showErrorAfterInput: true,
        errorMsgClass: 'form__field-error',
        fieldLineClass: 'form__field'
      });
      var uploaderContainer = item.querySelector('.js-uploader');
      if (uploaderContainer) {
        var uploader = new TurboUploader(uploaderContainer);
      }

      form.showErrorMessage = function (message) {
        if ($('.form__row--error', item).length) {
          $('.form__row--error', item).show();
          $('.form__error-msg', item).html(message);
        } else {
          $('.form__error', item).html(message);
        }
      };

      form.showSuccessMessage = function (message, json) {
        if (item.attributes.name.value === 'ajax_new_order') {
          window.location = json[2];
        }

        $('#success .popup__top-title').html(message);
        $('<a href="#success"></a>').magnificPopup().click();
        this.reset();
        if (uploader) {
          uploader.reset();
        }
      };

      form.showPreloader = function () {
        $(item).addClass('form--waiting-send');
      };

      form.hidePreloader = function () {
        $(item).removeClass('form--waiting-send');
      };

      var agree = item.querySelector('.js-agree');
      if (agree) {
        var submit = item.querySelector('button[type=submit]');
        var agreeCheck = function () {
          submit.disabled = !agree.checked;
          if (submit.disabled) {
            submit.classList.add('btn--disable');
          } else {
            submit.classList.remove('btn--disable');
          }
        };
        agree.addEventListener('change', agreeCheck);
        agreeCheck();
      }
    })
  }

  checkBusinessPopup();

  $('.messenger_main_icon').on('click', function (e) {
    $('.messenger_popover').addClass('messenger_active')
  })
  $('.messenger_close_icon').on('click', function (e) {
    $('.messenger_popover').removeClass('messenger_active')
  })
  $('.messenger_icon_link').on('click', function (e) {
    yaCounterEvent('click_messenger')
  })

  $('[data-toggle="tooltip"]').tooltip()

  $('.changeShopBtn').on('click', function (e){
    e.preventDefault();
    $.magnificPopup.open({
      items: {
        src: '#shops_modal'
      },
      type: 'inline'
    });
  });
  $('.js-close-popup').on('click', function (e) {
    e.preventDefault();
    $.magnificPopup.close();
  });

  // checkShopsPopup();

  $('.shop_card').on('click', function (e) {
    $('.full-loader').removeClass('h-invisible');
    const newShopId = $(this).data('shop');
    const returnToCard = $(this).parent().data('card');
    setCookie('shop_id',newShopId, 10);
    if (returnToCard) {
      window.location.href = "/order/";
    } else {
      window.location.reload();
    }
  })

});

function checkShopsPopup() {
  if ($('#shops_modal').length > 0) {
    const currShop = getCookie("shop_id")
    const availShops = $('#availShops').data('shops');
    if (currShop == null || availShops.indexOf(currShop) === -1) {
      if (!sessionStorage.getItem('startTimeShops')) {
        sessionStorage.setItem('startTimeShops', Date.now());
        viewShopsPopup();
      } else {
        var enterTime = sessionStorage.getItem('startTimeShops');
        var currentTime = Date.now();
        var spentTime = (currentTime - enterTime) / 1000;
        if (spentTime >= (18*60)) {
          viewShopsPopup();
          sessionStorage.setItem('startTimeShops', Date.now());
        }
      }
    }
  }
}

function viewShopsPopup() {
  $.magnificPopup.open({
    items: {
      src: '#shops_modal'
    },
    type: 'inline'
  });
}

function checkBusinessPopup() {
  // Всплывашка на подписку е-мейла и высылаем промокод,
  // не показывается, если юзер закрыл жту всплываху
  // или уже ему отправлялось сообщение. Смотрим localStorage
  if ($('#business').length > 0) {
    if (getCookie("business_success") == null && getCookie("business_close") == null) {

      if (!sessionStorage.getItem('startTime')) {
        sessionStorage.setItem('startTime', Date.now());
      }

      var enterTime = sessionStorage.getItem('startTime');

      function showPopup () {
        var currentTime = Date.now();
        var spentTime = (currentTime - enterTime) / 1000;
        if (spentTime >= 30) {
          clearInterval(timer);
          viewBusinessPopup();
        }
      }
      var timer = setInterval(showPopup, 10000);

    } else {
      $('#business').remove();
    }
  }
}

function viewBusinessPopup() {
  if ($('body').find('.mfp-ready').length) {
    setTimeout(viewBusinessPopup(), 30000);
  } else {
    $('<a href="#business"></a>').magnificPopup({
      type: 'inline',
      midClick: true,
      callbacks: {
        open: function () {
          $('.mfp-close').on('click', function () {
            setCookie('business_close', 'true', 1);
            // console.log('close mfpm this');
          });
        },
      }
    }).trigger('click');
  }
}

function sendDatalayer(event, items, orderInfo) {
  if (event && items) {
    // console.log('send event=' + event + ' ecommerce=');
    var ecommerceObj = new Object();
    if (typeof (orderInfo) !== 'undefined' && orderInfo) {
      ecommerceObj = orderInfo;
    }
    ecommerceObj.items = items;

    // console.log(ecommerceObj);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
    window.dataLayer.push({
      event: event,
      ecommerce: ecommerceObj
    });
  }
}

function getItemForDatalayer(data, qty) {
  if (typeof (qty) === 'undefined') {
    qty = 1;
  }
  var item = {
    item_name: data.title, // Name or ID is required.
    item_id: data.code,
    price: data.price,
    quantity: qty,
    category: data.category_path[0],
  };

  var index, len;
  for (index = 0, len = data.category_path.length; index < len; ++index) {
    if (index) {
      item['category' + (index + 1)] = data.category_path[index];
    }
  }

  return item;
}

function yaCounterEvent(target_name) {
  // console.log('send new reach goal=' + target_name);

  if (typeof (ym) != 'undefined')
    ym(52610872, 'reachGoal', target_name);

  // var _tmr = window._tmr || (window._tmr = []);
  // _tmr.push({ id: "3074232", type: "reachGoal", goal: target_name });

  if (typeof (gtag) != 'undefined')
    gtag('event', target_name);

  if (typeof (fbq) != 'undefined')
    fbq('track', 'Lead');

};

function setCookie(name,value,days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}
function eraseCookie(name) {
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function startLoader() {
  $('.full-loader').removeClass('h-invisible');
}
function stopLoader() {
  $('.full-loader').addClass('h-invisible');
}
